import { render, staticRenderFns } from "./PoolRivalPassConfig.vue?vue&type=template&id=6f9ca219"
import script from "./PoolRivalPassConfig.vue?vue&type=script&lang=js"
export * from "./PoolRivalPassConfig.vue?vue&type=script&lang=js"
import style0 from "./PoolRivalPassConfig.vue?vue&type=style&index=0&id=6f9ca219&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports